import axios      from 'axios';

let API_URL = '';
if (process.env.REACT_APP_API_URL) {
  API_URL = process.env.REACT_APP_API_URL;
}

const requests = {
  get: (url: string, body: any) => {
    return axios.get(API_URL + url, body);
  },

  delete: (url: string) => {
    return axios.delete(API_URL + url);
  },

  post: (url: string, body: any) => {
    return axios.post(API_URL + url, body);
  },

  put: (url: string, body: any, headers: any) => {
    return axios.put(API_URL + url, body, headers);
  }
};

export default requests;



// WEBPACK FOOTER //
// ./src/helpers/requests.helper.js